import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import { ModalService, MobileModal } from "../modal";

import "./PauseInternetModal.scss";

export const MobileModalListItems = ({ items, modal }) => {
  return (
    <ul className="pause-internet__mobile-modal__list">
      {items.map((item) => (
        <li key={item.id}>
          <button
            className="pause-internet__mobile-modal__item-button"
            type="button"
            onClick={() => {
              item.action();
              modal.resolve();
            }}
          >
            {item.content}
          </button>
        </li>
      ))}
    </ul>
  );
};

export const PauseInternetMobileModal = ({ modal, items, header }) => {
  return (
    <MobileModal
      modal={modal}
      header={header}
      content={<MobileModalListItems items={items} modal={modal} />}
    />
  );
};

export function PauseInternetModal({ items, renderToggle, header }) {
  return renderToggle({
    onClick: () => {
      ModalService.show((modal) => ({
        dialog: (
          <PauseInternetMobileModal
            modal={modal}
            items={items}
            header={header}
          />
        ),
      }))
        .then(_.noop)
        .catch(_.noop);
    },
  });
}

PauseInternetModal.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      content: PropTypes.node,
      action: PropTypes.func,
    })
  ),
  renderToggle: PropTypes.func.isRequired,
};
